/**组件布局类型-基础布局组件标识 */
export const MENU_COMPONENT_LAYOUT_BASIC = 'BasicLayout';

/**组件布局类型-空白布局组件标识 */
export const MENU_COMPONENT_LAYOUT_BLANK = 'BlankLayout';

/**组件布局类型-内链接布局组件标识 */
export const MENU_COMPONENT_LAYOUT_LINK = 'LinkLayout';

/**菜单类型-目录 */
export const MENU_TYPE_DIR = 'D';

/**菜单类型-菜单 */
export const MENU_TYPE_MENU = 'M';

/**菜单类型-按钮 */
export const MENU_TYPE_BUTTON = 'B';

/**菜单内嵌地址标识-带/前缀 */
export const MENU_PATH_INLINE = '/inline';
